import React, {useEffect, useState} from 'react'
import {Form} from 'formik'
import {useIntl} from 'react-intl'
import {Investors} from '../../core/_constants'
import {OverlayTrigger, Table, Tooltip} from 'react-bootstrap'
import {ToolTipUI} from '../../../widgets/components/UI/ToolTipUI'
import {getActiveRound} from '../../../investor-database/core/_requests'
import {useAuth} from '../../../auth'
import {DisplayImage} from '../../../widgets/components/General/DisplayImage'
import {Spinner} from '../../../widgets/components/General/Spinner'
import {toast} from 'react-toastify'
import {getInvestorUserforRound} from '../../core/_request'
import {getMailInfo} from '../../../profile/core/_requests'
/* eslint-disable react-hooks/exhaustive-deps */
const InvestorList = ({
  formik,
  checkedAll,
  setCheckedAll,
  investorUsers,
  setInvestorUsers,
  setSelectedTypeInvestors,
  setNextButtonDisable,
  nextButtonDisable,
}: {
  formik: any
  checkedAll: boolean
  setCheckedAll: any
  investorUsers: any
  setInvestorUsers: any
  setSelectedTypeInvestors: any
  setNextButtonDisable: any
  nextButtonDisable: boolean
}) => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const [roundId, setRoundId] = useState<number>()
  const [page] = useState(1)
  const [search, setSearch] = useState('')
  const [loadingInvestorList, setloadingInvestorList] = useState<boolean>()
  const [isMailerAvailable, setIsMailerAvailable] = useState(false)
  const [isNylasMailerAvailable, setIsNylasMailerAvailable] = useState(false)

  const handleSearch = (event: any) => {
    if (event.target.value !== undefined) {
      setSearch(event.target.value)
    }
  }
  const onSubmit = () => {}

  // check if user has mailer setup
  useEffect(() => {
    if (companyId) {
      getMailerInfo()
    }
  }, [companyId])

  useEffect(() => {
    const activeRound = async () => {
      try {
        const {
          data: {data, success, errors},
        } = await getActiveRound(Number(companyId))
        if (success) {
          setRoundId(data?.roundId)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
    if (companyId) {
      activeRound()
    }
  }, [companyId])

  // Convert this into 2 different API for existing and preospective
  const getInvestorUser = async () => {
    setloadingInvestorList(true)
    try {
      const {
        data: {
          data: {data: investorUserData},
          success,
        },
      } =
        formik.values.selectedTypeInvestor === 'existing'
          ? await getInvestorUserforRound('existing', search, roundId, page, 12)
          : await getInvestorUserforRound('prospective', search, roundId, page, 12)

      if (success) {
        let inv = investorUserData.map((ele: any) => {
          return {
            name: ele.name,
            investorUserId: ele.investorUserId,
            investorId: ele?.investor?.investorId,
            investorName: ele?.investor?.name,
            file: ele?.file || {},
            investorFile: ele?.investor?.file || {},
            checked: false,
            greeting: '',
            greetingName: '',
            email: ele.email,
          }
        })
        setloadingInvestorList(false)
        if (!!formik.values.selectedInvestorUserIds.length) {
          const updatedInv = inv.map((investorUser: any) => {
            const data = formik.values.selectedInvestorUserIds.find(
              (selectedInvestorUser: {investorUserId: number}) =>
                selectedInvestorUser.investorUserId === investorUser.investorUserId
            )
            if (data) {
              return {
                ...investorUser,
                checked: data.checked,
                greeting: data.greeting,
                greetingName: data.greetingName,
              }
            } else {
              return investorUser
            }
          })
          setInvestorUsers([...updatedInv])
        } else {
          if (formik.values.personalizeEmail) {
            setInvestorUsers([
              ...inv.map((investor: any) => {
                return {
                  ...investor,
                  greeting: 'Dear',
                  greetingName: investor.name,
                }
              }),
            ])
          } else {
            setInvestorUsers([...inv])
          }
        }
      }
    } catch (err) {
      setloadingInvestorList(false)
    }
  }

  // get mailer info
  const getMailerInfo = async () => {
    try {
      const {
        data: {success, data, errors},
      } = await getMailInfo(companyId)
      if (success) {
        if (
          data.isActive === 'postmark' ||
          data.isActive === 'sendgrid' ||
          data.isActive === 'smtp'
        ) {
          setIsMailerAvailable(true)
        }

        if (data.isNylasActive === 'nylasGoogle' || data.isNylasActive === 'nylasMicrosoft') {
          setIsNylasMailerAvailable(true)
        }
      } else {
        console.log(errors)
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formik.values.selectedTypeInvestor && roundId) {
      getInvestorUser()
    }
  }, [page, search, roundId])

  useEffect(() => {
    let mailerNotSetupError = null
    if (formik.values.selectedTypeInvestor === 'prospective' && !isMailerAvailable) {
      mailerNotSetupError =
        'Please setup promotional mailer first. Go to Settings => Promotional Emails'
    } else if (formik.values.selectedTypeInvestor === 'existing' && !isNylasMailerAvailable) {
      mailerNotSetupError =
        'Please setup transactional mailer first. Go to Settings => Transactional Emails'
    }

    if (mailerNotSetupError) {
      formik.setFieldValue(`selectedTypeInvestor`, '') // clear radio button
      setInvestorUsers([])
      toast.error(formatMessage({id: mailerNotSetupError}), {
        autoClose: 5000,
      })
    } else {
      if (
        formik.values.selectedTypeInvestor === 'prospective' ||
        formik.values.selectedTypeInvestor === 'existing'
      ) {
        setSelectedTypeInvestors(formik.values.selectedTypeInvestor)
        formik.setFieldValue(`selectedInvestorUserIds`, [...[]])
        getInvestorUser()
      } else {
        formik.setFieldValue(`selectedInvestorUserIds`, [...[]])
      }
    }
  }, [formik.values.selectedTypeInvestor, roundId]) // eslint-disable-next-line react-hooks/exhaustive-deps

  const handleCheckboxSelected = (e: boolean, id: number, i: number) => {
    if (!!formik.values.selectedInvestorUserIds.length) {
      const data = formik.values.selectedInvestorUserIds.find(
        (investorUser: {investorUserId: number}) => investorUser.investorUserId === id
      )
      if (data) {
        if (e && data.investorUserId === id) {
          data['checked'] = true
        } else if (!e && data.investorUserId === id) {
          data['checked'] = false
        }
        const investorUserData = investorUsers.find(
          (investorUser: {investorUserId: number}) => investorUser.investorUserId === id
        )

        if (e && investorUserData.investorUserId === id) {
          investorUserData['checked'] = true
        } else if (!e && investorUserData.investorUserId === id) {
          investorUserData['checked'] = false
        }
        setInvestorUsers([...investorUsers])
        formik.setFieldValue(`selectedInvestorUserIds`, [...formik.values.selectedInvestorUserIds])
      } else {
        const data = investorUsers.find(
          (investorUser: {investorUserId: number}) => investorUser.investorUserId === id
        )
        if (e && data.investorUserId === id) {
          data['checked'] = true
        } else if (!e && data.investorUserId === id) {
          data['checked'] = false
        }
        setInvestorUsers([...investorUsers])
        formik.setFieldValue(`selectedInvestorUserIds`, [
          ...formik.values.selectedInvestorUserIds,
          data,
        ])
      }
    } else {
      let invest = investorUsers.map((investorUser: any) => {
        if (e && investorUser.investorUserId === id) {
          investorUser['checked'] = true
        } else if (!e && investorUser.investorUserId === id) {
          investorUser['checked'] = false
        }
        return investorUser
      })
      formik.setFieldValue(`selectedInvestorUserIds`, [
        ...formik.values.selectedInvestorUserIds,
        ...invest,
      ])
    }
  }

  const handleAllCheckbox = (e: boolean) => {
    if (e) {
      let invest = investorUsers.map((item: any) => {
        if (!!item.email.length) {
          item['checked'] = true
        }
        return item
      })
      if (!!formik.values.selectedInvestorUserIds.length) {
        invest.forEach((inv: any) => {
          const index = formik.values.selectedInvestorUserIds.findIndex(
            (investorUser: {investorUserId: number}) =>
              investorUser.investorUserId === inv.investorUserId
          )
          if (index !== -1) {
            // update data
            formik.values.selectedInvestorUserIds[index].checked = true
            formik.setFieldValue('selectedInvestorUserIds', [
              ...formik.values.selectedInvestorUserIds,
            ])
          } else {
            // add new investor
            formik.setFieldValue('selectedInvestorUserIds', [
              ...formik.values.selectedInvestorUserIds,
              inv,
            ])
          }
        })
      } else {
        formik.setFieldValue('selectedInvestorUserIds', [...invest])
      }
      setInvestorUsers([...invest])
    } else {
      let invest = investorUsers.map((item: any) => {
        item['checked'] = false
        return item
      })
      if (!!formik.values.selectedInvestorUserIds.length) {
        invest.forEach((inv: any) => {
          const index = formik.values.selectedInvestorUserIds.findIndex(
            (investorUser: {investorUserId: number}) =>
              investorUser.investorUserId === inv.investorUserId
          )
          if (index !== -1) {
            // update data
            formik.values.selectedInvestorUserIds[index].checked = false
            formik.setFieldValue('selectedInvestorUserIds', [
              ...formik.values.selectedInvestorUserIds,
            ])
          } else {
            // add new investor
            formik.setFieldValue('selectedInvestorUserIds', [
              ...formik.values.selectedInvestorUserIds,
              inv,
            ])
          }
        })
      } else {
        formik.setFieldValue('selectedInvestorUserIds', [...invest])
      }
      setInvestorUsers([...invest])
    }
  }
  const handleGreeting = (e: string, id: number, i: number) => {
    const foundGreeting = formik.values.selectedInvestorUserIds.find((item: any) => {
      return item.investorUserId === id
    })

    if (foundGreeting) {
      formik.setFieldValue(`selectedInvestorUserIds[${i}]['greeting']`, e)
    }
  }
  const handleGreetingName = (e: string, id: number, i: number) => {
    const foundGreeting = formik.values.selectedInvestorUserIds.find((item: any) => {
      return item.investorUserId === id
    })

    if (foundGreeting) {
      formik.setFieldValue(`selectedInvestorUserIds[${i}].greetingName`, e)
    }
  }

  useEffect(() => {
    if (formik.values.selectedInvestorUserIds) {
      const foundTrue = formik.values.selectedInvestorUserIds.find(
        (selectedInvestorUser: {checked: boolean}) => selectedInvestorUser.checked === true
      )
      if (foundTrue) {
        setNextButtonDisable(false)
      } else {
        setNextButtonDisable(true)
      }
    }
  }, [formik.values.selectedInvestorUserIds])

  useEffect(() => {
    let allInvestorUsers: any = []
    if (formik.values.personalizeEmail) {
      allInvestorUsers = formik.values.selectedInvestorUserIds.map((investorUser: any) => {
        return {
          ...investorUser,
          greeting: 'Dear',
          greetingName: investorUser.name,
        }
      })
    } else {
      allInvestorUsers = formik.values.selectedInvestorUserIds.map((investorUser: any) => {
        return {
          ...investorUser,
          greeting: '',
          greetingName: '',
        }
      })
    }
    if (formik.values.personalizeEmail && !formik.values.selectedInvestorUserIds.length) {
      const newInvestors = investorUsers.map((investorUser: any) => {
        return {
          ...investorUser,
          greeting: 'Dear',
          greetingName: investorUser.name,
        }
      })

      setInvestorUsers([...newInvestors])
    }
    formik.setFieldValue('selectedInvestorUserIds', [...allInvestorUsers])
  }, [formik.values.personalizeEmail])

  return (
    <>
      {loadingInvestorList ? <Spinner /> : null}
      <div className='col-12'>
        <p className=' p-0 font-weight-600 font-size-13'>
          {formatMessage({
            id: 'Send personalized email in bulk. Create and re-use email templates.',
          })}
        </p>
        <Form onSubmit={onSubmit}>
          <div className=''>
            <div>
              <div className='ms-0 row my-5 mw-450px'>
                <div className='col-6 form-check'>
                  <input
                    className='form-check-input'
                    type='radio'
                    id='EXISTING'
                    value={Investors.EXISTING}
                    name='selectedTypeInvestor'
                    onChange={(e) => formik.setFieldValue('selectedTypeInvestor', e.target.value)}
                  />
                  <label className='form-check-label' htmlFor='EXISTING'>
                    {formatMessage({id: 'Exisitng Investors'})}
                  </label>
                </div>
                <div className='col-6 form-check'>
                  <input
                    id='PROSPECTIVE'
                    className='form-check-input'
                    type='radio'
                    value={Investors.PROSPECTIVE}
                    name='selectedTypeInvestor'
                    onChange={(e) => {
                      formik.setFieldValue('selectedTypeInvestor', e.target.value)
                    }}
                  />
                  <label className='form-check-label' htmlFor='PROSPECTIVE'>
                    {formatMessage({id: 'Prospective Investors'})}
                  </label>
                </div>
              </div>
              {formik.errors.selectedTypeInvestor && (
                <div className='text-danger mb-2'>{formik.errors.selectedTypeInvestor}</div>
              )}

              <div className='col-12 form-check my-5'>
                <input
                  className='form-check-input h-20px w-20px'
                  type='checkbox'
                  value={formik.values.personalizeEmail}
                  id='personalizeemail'
                  checked={formik.values.personalizeEmail}
                  name='personalizeEmail'
                  onChange={(e) => formik.setFieldValue('personalizeEmail', e.target.checked)}
                />
                <label className='form-check-label' htmlFor='personalizeemail'>
                  {formatMessage({
                    id: 'Personalize email (name, greeting, firm name, industry, portfolio firm, round)',
                  })}
                </label>
                <ToolTipUI
                  tooltipText={formatMessage({id: 'GLOBAL.TOOLTIP.SEND_MAIL.PERSONALIZE_MAIL'})}
                />
              </div>
            </div>
          </div>
          <label className='mb-4 ps-1'>
            {formatMessage({id: 'Select Investors'})}
            <ToolTipUI
              tooltipText={formatMessage({id: 'GLOBAL.TOOLTIP.INVESTOR_LIST.SELECT_INVESTOR'})}
            />
          </label>
          {formik.values.selectedTypeInvestor && nextButtonDisable && (
            <div className='text-danger mb-2'>
              {' '}
              {formatMessage({id: 'Select atleast one investor'})}
            </div>
          )}

          <div className='input-group w-100 '>
            <div className='form-outline w-100'>
              <input
                type='search'
                onChange={(e) => {
                  handleSearch(e)
                }}
                id='form1'
                placeholder={formatMessage({id: 'Search by name or email '})}
                className='form-control w-100 rounded-0 bg_color_preview font-size-12 font-weight-400'
              />
            </div>
          </div>
          <div className='border px-5 py-8'>
            <Table responsive>
              <tr>
                <th className=''>
                  <input
                    type='checkbox'
                    name='checkedAll'
                    value={formik.values.checkedAll}
                    checked={formik.values.checkedAll}
                    onChange={(e) => {
                      formik.setFieldValue('checkedAll', e.target.checked)
                      handleAllCheckbox(e.target.checked)
                    }}
                  />
                </th>
                <th className='p-2'> {formatMessage({id: 'Full Name'})}</th>
                <th className='p-2'> {formatMessage({id: 'Contact Person'})}</th>
                <th className='p-2'>{formatMessage({id: 'Email'})} </th>
                {formik.values.personalizeEmail ? (
                  <th className='p-2'> {formatMessage({id: 'Greeting'})}</th>
                ) : (
                  ''
                )}
                {formik.values.personalizeEmail ? (
                  <th className='p-2'> {formatMessage({id: 'Greeting name'})}</th>
                ) : (
                  ''
                )}
              </tr>
              <tbody>
                {investorUsers &&
                  investorUsers.map((item: any, i: number) => (
                    <tr key={item.investorUserId} className='border-bottom border-bottom-2'>
                      <td>
                        <div className='d-inline-flex mt-3'>
                          <div className='d-flex gap-3'>
                            {!item.email.length ? (
                              <OverlayTrigger
                                placement='bottom'
                                overlay={
                                  <Tooltip id='tooltip'>
                                    <p className='m-0'>
                                      {formatMessage({
                                        id: 'Email Id is not present for the Contant Person',
                                      })}
                                    </p>
                                  </Tooltip>
                                }
                              >
                                <input
                                  type='checkbox'
                                  name={`${item.investorUserId}`}
                                  onChange={(e) =>
                                    handleCheckboxSelected(
                                      e.target.checked,
                                      item?.investorUserId,
                                      i
                                    )
                                  }
                                  checked={item.checked}
                                  disabled={!item.email.length}
                                />
                              </OverlayTrigger>
                            ) : (
                              <input
                                className='cursor-pointer'
                                type='checkbox'
                                name={`${item.investorUserId}`}
                                onChange={(e) =>
                                  handleCheckboxSelected(e.target.checked, item?.investorUserId, i)
                                }
                                checked={item.checked}
                              />
                            )}

                            {item && item.investorFile && (
                              <DisplayImage
                                imgName={item?.investorFile?.name || ''}
                                width='24px'
                                height='24px'
                                className='border object-contain rounded-circle'
                                alt={item?.investorFile?.name || ''}
                              />
                            )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <input
                          className={`form-control h-35px font-size-12 bg_color_preview`}
                          type='text'
                          name={`${item?.investorName}}`}
                          value={item?.investorName}
                          readOnly
                          disabled
                        />
                      </td>

                      <td>
                        <input
                          className={`form-control h-35px font-size-12 bg_color_preview`}
                          type='text'
                          name={`${item.name}}`}
                          value={item.name}
                          readOnly
                          disabled
                        />
                      </td>
                      <td>
                        <input
                          className={`form-control h-35px font-size-12 bg_color_preview`}
                          type='text'
                          name={`${item.email}}`}
                          value={item.email}
                          readOnly
                          disabled
                        />
                      </td>

                      {formik.values.personalizeEmail ? (
                        <td>
                          <input
                            type='text'
                            className={`form-control h-35px font-size-12`}
                            defaultValue={item.greeting || 'Dear'}
                            name={`greeting${item.investorUserId}`}
                            onChange={(e) => {
                              handleGreeting(e.target.value, item.investorUserId, i)
                            }}
                            disabled={!item.checked}
                          />
                        </td>
                      ) : (
                        ''
                      )}
                      {formik.values.personalizeEmail ? (
                        <td>
                          {' '}
                          <input
                            type='text'
                            className={`form-control h-35px font-size-12`}
                            defaultValue={item.greetingName || item.name}
                            name={`greetingname${item.name}}`}
                            onChange={(e) => {
                              handleGreetingName(e.target.value, item.investorUserId, i)
                            }}
                            disabled={!item.checked}
                          />
                        </td>
                      ) : (
                        ''
                      )}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </Form>
      </div>
    </>
  )
}

export {InvestorList}
